import { DataFormat } from './DataFormat';
import { FormatCam } from './FormatCam';

export class DataFormats {
    static RegisteredFormats: DataFormat[] = [
        new FormatCam(),
    ];

    public static GetFormat(type: string) : DataFormat | null {
        for (let format of this.RegisteredFormats) {
            if (format.getTypeName() == type) {
                return format;
            }
        }
        return null;
    }
}